<template>
    <div>
        <div class="page_top">
            <div class="title">
                <i class="icon" id="icon" @click="back()"></i>
                <span class="header-text">詢價詳情</span>
            </div>
        </div>
        <div class="container mt-4 scrollable-container">
            <!-- 注意事項 -->
            <el-card class="mb-4" shadow="always" style="border-color: #909399">
                <span class="fw-bold fs-5">注意事項</span>
                <div class="text-muted mt-2">
                    <p class="mb-2">1.價格不包含代收費用</p>
                    <p class="mb-2">2.報價後期限內付款完成才成算成立</p>
                    <p class="mb-2">3.尾款於託運後收取，包含代收費費用</p>
                </div>
            </el-card>
            <el-tag :type="getStatusTagType(order.status.id)" class="ml-2">
                {{ order.status.name || '未知' }}
            </el-tag>
            <!-- 詢價資訊 -->
            <el-card v-if="fees.shipping !== ''" class="mb-4" shadow="always" style="border-color: #909399;color: #303133">
                <span class="fw-bold fs-5 d-flex align-items-center">詢價資訊</span>
                <div class="text-muted mt-2">
                    <div class="flex-space-between mb-1 mt-3">
                        <span class="mb-1 fw-bold" style="color: #303133">付款有效期限</span>
                        <span class="mb-1 fw-bold" style="color: #303133">{{ order.valid_until }}</span>
                    </div>
                    <div class="flex-space-between mb-1">
                        <span class="mb-1 fw-bold" style="color: #303133">報價</span>
                        <span class="mb-1 fw-bold" style="color: #303133">
                            {{ fees.shipping.amount }}
                        </span>
                    </div>
                    <div class="flex-space-between mb-1 " v-if="fees.shipping.pay_time">
                        <span class="mb-1 fw-bold" style="color: #303133">付款日期</span>
                        <span class="mb-1 fw-bold" style="color: #303133">{{ fees.shipping.pay_time }}</span>
                    </div>
                    <div v-if="order.driver_info" class="mb-4">
                        <p class="mb-2 fw-bold" style="color: #303133">司機資訊</p>
                        <span style="white-space: pre-line; line-height: 1.5;">{{ order.driver_info }}</span>
                    </div>
                    <div v-if="fees.shipping.payment_type == 'BARCODE' && !fees.shipping.pay_time">
                        <span class="mb-1 fw-bold" style="color: #303133">超商條碼繳費</span>
                        <div class="mb-1 w-100">
                            <vue-barcode :value="fees.shipping.barcode_1" format="CODE128" />
                            <vue-barcode :value="fees.shipping.barcode_2" format="CODE128" />
                            <vue-barcode :value="fees.shipping.barcode_2" format="CODE128" />
                        </div>
                    </div>
                    <div v-if="fees.shipping.payment_type == 'CVS' && !fees.shipping.pay_time" class="mt-2">
                        <div class="flex-space-between mb-1 mt-3">
                            <span class="mb-1 fw-bold" style="color: #303133">超商代碼繳費</span>
                            <span class="mb-1 fw-bold" style="color: #303133">{{ fees.shipping.code_no }}</span>
                        </div>
                        <div class="d-flex w-100 justify-content-center">
                            <div class="mt-5" style="width: 180px">
                                <VueQrcode :value="fees.shipping.code_no" :text="fees.shipping.code_no" :size="180" />
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>
            <!-- 代墊資訊-->
            <el-card v-if="fees.advance !== ''" class="mb-4" shadow="always" style="border-color: #909399;color: #303133">
                <div class="flex-space-between align-center  mb-2">
                    <span class="fw-bold fs-5 d-flex align-items-center">代墊資訊</span>
                </div>
                <div class="text-muted mt-2">
                    <div class="flex-space-between mb-1 mt-3">
                        <span class="mb-1 fw-bold" style="color: #303133">代墊金額</span>
                        <span class="mb-1 fw-bold" style="color: #303133">{{ order.fees && order.fees.find(f => f.type === 2) ? order.fees.find(f => f.type === 2).amount : '' }}</span>
                    </div>
                    <div class="flex-space-between mb-1">
                        <span class="mb-1 fw-bold" style="color: #303133">代墊項目</span>
                        <span class="mb-1 fw-bold" style="color: #303133; white-space: pre-line;">
                            {{ order.misc_fee }}
                    </span>
                    </div>
                    <div class="flex-space-between mb-1 " v-if="fees.advance.pay_time">
                        <span class="mb-1 fw-bold" style="color: #303133">付款日期</span>
                        <span class="mb-1 fw-bold" style="color: #303133">{{ fees.advance.pay_time }}</span>
                    </div>
                    <div v-if="fees.advance.payment_type == 'BARCODE' && !fees.advance.pay_time">
                        <span class="mb-1 fw-bold" style="color: #303133">超商條碼繳費</span>
                        <div class="mb-1 w-100">
                            <vue-barcode :value="fees.advance.barcode_1" format="CODE128" />
                            <vue-barcode :value="fees.advance.barcode_2" format="CODE128" />
                            <vue-barcode :value="fees.advance.barcode_2" format="CODE128" />
                        </div>
                    </div>
                    <div v-if="fees.advance.payment_type == 'CVS' && !fees.advance.pay_time" class="mt-2">
                        <div class="flex-space-between mb-1 mt-3">
                            <span class="mb-1 fw-bold" style="color: #303133">超商代碼繳費</span>
                            <span class="mb-1 fw-bold" style="color: #303133">{{ fees.advance.code_no }}</span>
                        </div>
                        <div class="d-flex w-100 justify-content-center">
                            <div class="mt-5" style="width: 180px">
                                <VueQrcode :value="fees.advance.code_no" :text="fees.advance.code_no" :size="180" />
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>

            <!-- 運輸資訊 -->
            <el-card class="mb-4" shadow="always" style="border-color: #909399">
                <span class="fs-5 fw-bold">運輸資訊</span>
                <div class="mt-3">
                    <p class="mb-1"><strong>啟運日：</strong></p>
                    <p class="mb-2">{{ order.start_date }}</p>
                    <p class="mb-1"><strong>啟運地：</strong></p>
                    <p class="mb-2">{{ transportInfo.origin.name }}</p>
                    <p class="mb-2">{{ transportInfo.origin.full_address }}</p>
                    <p class="mb-1"><strong>送達地：</strong></p>
                    <p class="mb-2">{{ transportInfo.destination.name }}</p>
                    <p class="mb-2">{{ transportInfo.destination.full_address }}</p>
                </div>
                <p class="mb-2 fw-bold" style="color: #303133">備註</p>
                <span style="white-space: pre-line; line-height: 1.5;">{{ order.remarks }}</span>
            </el-card>
            <!-- 貨物資訊 -->
            <el-card class="mb-4" shadow="always" style="border-color: #909399">
                <span class="fs-5 fw-bold">貨物資訊</span>
                <div class="mt-3">
                    <div class=" flex-space-between mb-1">
                        <span class="mb-1 fw-bold" style="color: #303133">危險物品：</span>
                        <span class="mb-1 ">{{ order.is_dangerous ? '是' : '否' }}</span>
                    </div>
                    <div class=" flex-space-between mb-1">
                        <span class="mb-1 fw-bold" style="color: #303133">貨櫃規格：</span>
                        <span class="mb-1 ">{{ order.container_type.name }}</span>
                    </div>
                    <div class="mb-1">
                        <span class="m fw-bold" style="color: #303133">貨物名稱：</span>
                        <div class="my-2">{{ order.title }}</div>
                    </div>
                    <div class="mb-1">
                        <span class="m fw-bold" style="color: #303133">貨物內容說明：</span>
                        <div class="my-2">{{ order.details }}</div>
                    </div>
                </div>
            </el-card>

            <!-- 聯絡資訊 -->
            <el-card class="mb-4" shadow="always" style="border-color: #909399">
                <span class="fs-5 fw-bold">聯絡資訊</span>
                <div class="mt-3">
                    <div class=" flex-space-between mb-1">
                        <span class="mb-1 fw-bold" style="color: #303133">公司名稱：</span>
                        <span class="mb-1">{{ order.company_name }}</span>
                    </div>
                    <div class=" flex-space-between mb-1">
                        <span class="mb-1 fw-bold" style="color: #303133">聯絡人：</span>
                        <span class="mb-1">{{ order.contact_person }}</span>
                    </div>
                    <div class=" flex-space-between mb-1">
                        <span class="mb-1 fw-bold" style="color: #303133">電話：</span>
                        <span class="mb-1">{{ order.phone }}</span>
                    </div>
                    <div class=" flex-space-between mb-1">
                        <span class="mb-1 fw-bold" style="color: #303133">公司統編</span>
                        <span class="mb-1">{{ order.business_number }}</span>
                    </div>
                </div>
            </el-card>
            <!-- 提交按鈕 -->
            <div class="text-center mb-4 ">
                <el-button v-if="[3,6].includes(order.status.id) &&  order.payment_code_generated == 0"  type="warning" @click="goToPay" style="width: 80%;">付款</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import FN from "@/components/fn.vue";
import VueBarcode from 'vue-barcode';
import VueQrcode from 'vue-qrcode-component';


export default {
    components:{
        VueBarcode,
        VueQrcode,
    },
    mixins: [FN],
    data() {
        return {
            id: null,
            is_loading: false,
            order: {
                container_type: {
                    name: ''
                },
                status: {
                    name: ''
                }
            }
            ,
            inquiryInfo: {
                expiryDate: '2024-07-25',
                deposit: 'NT 1000',
                shippingFee: 'NT 1000',
                advancePayment: 'NT 1000',
                totalAmount: 'NT 1000',
                notes: '備註內容'
            },
            transportInfo: {
                origin: '',
                destination: '',
            },
            fees: {
                shipping: '',
                advance: ''
            }
        };
    },
    methods: {
        back() {
            this.$router.push('/container');
        },
        getData(id) {
            this.is_loading = true;
            this.FETCH({
                key: 'GET_SHIPMENT_ORDER_DETAIL',
                id: id,
            })
                .then((res) => {
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getChannel)
                    } else if (+(res || {}).code === 0) {
                        this.order = res.data;
                        this.setTransportInfoFromLocations(res.data.locations);
                        this.setFeesFromData(res.data.fees);
                        this.is_loading = false;

                    } else {
                        this.$notify({
                            title: '資料異常',
                            message: '請稍後再試。',
                            type: 'warning'
                        });
                        this.is_loading = false;
                        this.$router.push('/container'); // 跳轉到詢價列表頁面

                    }
                })
                .catch((err) => {
                    this.$router.push('/container'); // 跳轉到詢價列表頁面
                });
        },
        submitForm() {
            this.$notify({
                title: '成功',
                message: '付款成功',
                type: 'success'
            });
            this.$router.push('/container');
        },
        /**
         * 根據 locations 設定 transportInfo
         * @param {Array} locations - 包含啟運地和送達地的位置信息
         */
        setTransportInfoFromLocations(locations) {
            this.transportInfo = {
                origin: {
                    name:locations?.find(l => l.location_type === 1)?.name || '',
                    full_address:locations?.find(l => l.location_type === 1)?.full_address || '',
                },
                destination:{
                    name:locations?.find(l => l.location_type === 2)?.name || '',
                    full_address:locations?.find(l => l.location_type === 2)?.full_address || '',
                }
            };
        },

        /**
         * 根據狀態 id 回傳對應 el-tag type
         */
        getStatusTagType(statusId) {
            switch (statusId) {
                case 1: // 已建立
                    return 'info';
                case 2: // 報價中
                    return 'primary';
                case 3: // 待付訂金
                    return 'warning';
                case 4: // 等待運送
                    return 'info';
                case 5: // 運送中
                    return 'success';
                case 6: // 待付尾款
                    return 'warning';
                case 7: // 完成
                    return 'success';
                case 8: // 取消
                    return 'danger';
                case 9: // 失效
                    return 'danger';
                default:
                    return 'default';
            }
        },
        /**
         * 前往付款頁面
         * @param id
         */
        goToPay() {
            var id = this.id;
            this.$router.push({
                name: 'ContainerPayPage',
                params: {id: id},            // 傳 id
            });
        },
        /**
         * 根據後端回傳的費用資料設定 fees
         * @param {Array} feesArr - 後端回傳的費用資料陣列
         */
        setFeesFromData(feesArr) {
            this.fees.shipping = feesArr.find(f => f.type === 1) || '';
            this.fees.advance =  feesArr.find(f => f.type === 2) || '';
        }
    },
    mounted() {
        const id = this.$route.params.id;
        this.id = id;
        if (id) {
            this.getData(id);
        }
    }
};
</script>

<style>
.scrollable-container {
    max-height: 90vh;
    overflow-y: auto;
}

.flex-space-between {
    display: flex;
    justify-content: space-between;
}

.vue-barcode-element {
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>
